const DEFAULT_HALF_LIFE_MS = 7 * 24 * 60 * 60 * 1000;
const MIN_TIME_FACTOR = 0.12;
const INDEX_DECAY_PER_STEP = 0.11;

/**
 * Combines list position (MRU first) with exponential time decay so both order and
 * age affect weight. Used for recent-search match inference.
 */
export function searchEntryRecencyWeight(
  rankIndex: number,
  timestamp: number | undefined,
  nowMs: number,
  options?: { halfLifeMs?: number }
): number {
  const halfLife = options?.halfLifeMs ?? DEFAULT_HALF_LIFE_MS;
  const indexPart = 1 / (1 + Math.max(0, rankIndex) * INDEX_DECAY_PER_STEP);
  const ts = typeof timestamp === 'number' && Number.isFinite(timestamp) ? timestamp : nowMs;
  const ageMs = Math.max(0, nowMs - ts);
  const timePart = Math.exp((-ageMs * Math.LN2) / halfLife);
  const timeClamped = Math.max(MIN_TIME_FACTOR, timePart);
  return indexPart * timeClamped;
}
